import { render } from "./PreTestResult.vue?vue&type=template&id=52b5a902&scoped=true"
import script from "./PreTestResult.vue?vue&type=script&lang=js"
export * from "./PreTestResult.vue?vue&type=script&lang=js"

import "./PreTestResult.vue?vue&type=style&index=0&id=52b5a902&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b5a902"]])

export default __exports__